import { ButtonBase, Grid2, Typography } from '@mui/material';
import { MAIN_THEME_COLOR, WHITE } from '../assets/theme/Colors';

interface FilterTagProps {
	name: string;
	count?: number;
	isSelected: boolean;
	onSelect: (value: string) => void;
}

function FilterTag({ name, count, isSelected, onSelect }: FilterTagProps) {
	return (
		<ButtonBase
			onClick={() => onSelect(name)}
			sx={{
				backgroundColor: isSelected ? MAIN_THEME_COLOR : '#F9F8F9',
				borderRadius: '5px',
				padding: '5px',
			}}>
			<Typography
				fontSize={'14px'}
				color={
					isSelected ? WHITE : '#686868'
				}>{`${name} (${count})`}</Typography>
		</ButtonBase>
	);
}

export default FilterTag;
